import { Component, OnInit } from '@angular/core';
import { Guid } from '@lsq-frontend/remote-services/enterprise/common';
import { Color } from '@lsq-frontend/common-ui';
import { Icons } from '@lsq-frontend/common-ui';
import { ModalService } from '@lsq-frontend/common-ui';

@Component({
    selector: 'image-preview-modal',
    template: `
        <div class="modal-content">
            <div class="modal-header">
                <h1>
                    {{ title }}
                </h1>
            </div>
            <lsq-button
                appearance="transparent"
                class="close-button"
                ariaLabel="Close"
                (buttonClick)="closeModal()"
            >
                <lsq-icon aria-hidden="true" [type]="icons.Close" [color]="color.Black"> </lsq-icon>
            </lsq-button>
            <invoice-preview
                *ngIf="!checkKey && !invoiceKey && !documentKey"
                [imageId]="imageId"
                [imageIds]="imageIds"
                [downloadUrl]="downloadUrl"
                [totalPages]="totalPages"
                [filename]="filename"
            >
            </invoice-preview>
            <document-preview
                *ngIf="documentKey"
                [imageId]="documentKey"
                [downloadUrl]="downloadUrl"
                [totalPages]="totalPages"
                [filename]="filename"
            >
            </document-preview>
            <invoice-historical-preview
                *ngIf="invoiceKey"
                [imageId]="invoiceKey"
                [imageIds]="imageIds"
                [downloadUrl]="downloadUrl"
                [totalPages]="totalPages"
                [filename]="filename"
            >
            </invoice-historical-preview>
            <check-preview
                *ngIf="!!checkKey"
                [imageId]="imageId"
                [imageIds]="imageIds"
                [downloadUrl]="downloadUrl"
                [totalPages]="totalPages"
                [filename]="filename"
                [checkKey]="checkKey"
            >
            </check-preview>
        </div>
    `,
    styles: [
        `
            .close-button {
                cursor: pointer;
                position: absolute;
                top: 3rem;
                right: 3rem;
            }
            .modal-content {
                padding-bottom: 0;
            }
        `
    ]
})
export class ImagePreviewModalComponent implements OnInit {
    public title = '';
    public imageId: string;
    public imageIds: string[];
    public downloadUrl: string;
    public totalPages: number;
    public filename: string;
    public icons = Icons;
    public color = Color;
    public checkKey: number;
    public invoiceKey: number | Guid;
    public documentKey: Guid;

    constructor(public modalService: ModalService) {}

    public ngOnInit(): void {
        const modalData = this.modalService.modal.data;
        if (modalData) {
            this.title = modalData.title;
            this.imageId = modalData.imageId;
            this.imageIds = modalData.imageIds;
            this.downloadUrl = modalData.downloadUrl;
            this.totalPages = modalData.totalPages;
            this.filename = modalData.filename;
            this.checkKey = modalData.checkKey;
            this.invoiceKey = modalData.invoiceKey;
            this.documentKey = modalData.documentKey;
        }
    }

    public closeModal(): void {
        this.modalService.closeModal();
    }
}
